export function bindNoteContentByteLimit(textarea) {
    const maxContentBytes = Number.parseInt(String(textarea.dataset.maxContentBytes ?? ''), 10);
    const sync = () => {
        const isTooLarge = Number.isInteger(maxContentBytes)
            && new Blob([textarea.value.trim()]).size > maxContentBytes;
        textarea.setCustomValidity(isTooLarge
            ? `Note content must not exceed ${maxContentBytes} bytes.`
            : '');
    };

    sync();
    textarea.addEventListener('input', sync);

    return sync;
}
